/**
 * Collection Reviews Swiper
 * Initializes Swiper carousel for collection reviews section
 */

class CollectionReviewsSwiper {
  constructor() {
    this.swiperContainers = document.querySelectorAll('.collection-reviews__swiper');
    this.swiperInstances = [];
    this.init();
  }

  init() {
    // Load Swiper CSS and JS from CDN if not already loaded
    this.loadSwiperAssets().then(() => {
      this.initializeSwipers();
    });
  }

  loadSwiperAssets() {
    return new Promise((resolve) => {
      // Check if Swiper is already loaded
      if (typeof Swiper !== 'undefined') {
        resolve();
        return;
      }

      // Load Swiper CSS
      const swiperCSS = document.createElement('link');
      swiperCSS.rel = 'stylesheet';
      swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(swiperCSS);

      // Load Swiper JS
      const swiperJS = document.createElement('script');
      swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      swiperJS.onload = () => resolve();
      document.head.appendChild(swiperJS);
    });
  }

  initializeSwipers() {
    this.swiperContainers.forEach((container) => {
      const sectionId = container.id;
      
      const swiper = new Swiper(`#${sectionId}`, {
        slidesPerView: 1.12,
        spaceBetween: 12,
        centeredSlides: true,
        grabCursor: true,
        pagination: {
          el: `#${sectionId} .collection-reviews__pagination`,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },
        breakpoints: {
          // Tablet
          768: {
          centeredSlides: true,
            slidesPerView: 2,
            spaceBetween: 16,
          },
          // Desktop
          1280: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });

      this.swiperInstances.push(swiper);
    });
  }

  // Destroy all swiper instances (useful for cleanup)
  destroy() {
    this.swiperInstances.forEach((swiper) => {
      swiper.destroy(true, true);
    });
    this.swiperInstances = [];
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionReviewsSwiper();
  });
} else {
  new CollectionReviewsSwiper();
}

// Re-initialize on Shopify section load (Theme Editor)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.collection-reviews__swiper')) {
    new CollectionReviewsSwiper();
  }
});

/**
 * Handle anchor links to #reviews with offset
 */
function handleReviewsAnchor() {
  // Handle clicks on all anchor links pointing to #reviews
  document.querySelectorAll('a[href="#reviews"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const reviewsSection = document.getElementById('reviews');
      
      if (reviewsSection) {
        const offset = 100; // 100px spacing from top
        const elementPosition = reviewsSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        // Update URL hash without jumping
        history.pushState(null, null, '#reviews');
      }
    });
  });
  
  // Handle direct navigation to #reviews (e.g., page load with hash)
  if (window.location.hash === '#reviews') {
    setTimeout(() => {
      const reviewsSection = document.getElementById('reviews');
      if (reviewsSection) {
        const offset = 100;
        const elementPosition = reviewsSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100); // Small delay to ensure page is fully loaded
  }
}

// Initialize anchor handling when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', handleReviewsAnchor);
} else {
  handleReviewsAnchor();
}

// Re-initialize on Shopify section load (for dynamic content)
document.addEventListener('shopify:section:load', handleReviewsAnchor);
